// assets/card-pack.js
(function () {
  const SELECTORS = {
    packOptions: "[data-pack-options]",
    packRadio: "[data-pack-radio]",
    packLabel: "[data-pack-label]",
    cardWrapper: ".card-wrapper--pack, .card-wrapper",
    qtyInput: ".js-card-pack-quantity",
    priceCurrent: ".js-card-pack-price-current",
    priceCompare: ".js-card-pack-price-compare"
  };

  function updatePrice(element, price) {
    if (element && price) {
      element.textContent = price;
    }
  }

  function updateComparePrice(element, price) {
    if (!element) return;

    const hasPrice = price && String(price).trim();
    element.textContent = hasPrice ? price : "";
    element.classList.toggle("is-hidden", !hasPrice);
  }

  function applyPack(radio) {
    const qty = parseInt(radio.dataset.qty, 10) || 1;
    const group = radio.closest(SELECTORS.packOptions);
    const card = radio.closest(SELECTORS.cardWrapper) || document;

    if (group) {
      const labels = group.querySelectorAll(SELECTORS.packLabel);
      const currentLabel = radio.closest(SELECTORS.packLabel);

      labels.forEach((label) => {
        label.classList.toggle("selected", label === currentLabel);
      });
    }

    const qtyInput = card.querySelector(SELECTORS.qtyInput);

    // В quantity кладем ТОЛЬКО выбранный pack qty
    if (qtyInput) {
      qtyInput.value = String(qty);
      qtyInput.setAttribute("value", String(qty));
    }

    updatePrice(
      card.querySelector(SELECTORS.priceCurrent),
      radio.dataset.totalPriceFormatted
    );

    updateComparePrice(
      card.querySelector(SELECTORS.priceCompare),
      radio.dataset.comparePriceFormatted
    );
  }

  document.addEventListener("change", (e) => {
    const radio = e.target.closest(SELECTORS.packRadio);
    if (radio) applyPack(radio);
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SELECTORS.packOptions).forEach((group) => {
      const radio =
        group.querySelector(`${SELECTORS.packRadio}:checked`) ||
        group.querySelector(SELECTORS.packRadio);

      if (radio) applyPack(radio);
    });
  });
})();